module.exports = __webpack_public_path__ + "static/media/sample_loading_ports.a99ba701.csv";